export default ".pane {\n  /* margin-top: 3%;*/\n}"